<template>
	<div class="flex justify-between" style="flex-direction: column">
		<div class="flex">
			<div class="grid grid-cols-2 flex gap-12">
				<div v-for="(picture, index) in pictureArray" :key="index">
					<div class="flex flex-grow">
						<BaseImage
							:src="picture.imageData"
							:alt="$t('overview_image')"
							class="h-80"
							:rotation="picture.rotation"
							@tempDoc="setTempDoc($event, index)"
						/>
						<div @click="picture.rotation === 270 ? (picture.rotation = 0) : (picture.rotation += 90)" class="h-8 cursor-pointer pl-6 pr-6">
							<font-awesome-icon :icon="['fas', 'sync-alt']" class="text-connectProBlue justify-start" size="lg" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer class="justify-between content-center justify-items-center" style="display: flex; justify-content: center;" :is-back-button="false">
			<template #continueButton>
				<SaveButton style="min-width: fit-content; max-height: fit-content; " @click="save" class="btn-blue ml-6">
					{{ $t('upload') }}
				</SaveButton>
			</template>
		</Footer>
	</div>
</template>

<script>
import { DamagecasesApiFactory } from '@/api/generated';
import defaultConfiguration from '@/api/defaultConfiguration';
import Authentication from '@/mixins/Authentication';
import Validate from '@/mixins/Validate';
import Formatter from '@/mixins/Formatter';
import DunningStatus from '@/mixins/damagecase/DunningStatus';
import BaseImage from '@/components/forms/BaseImage.vue';
import SaveButton from '@/components/forms/buttons/SaveButton.vue';
import Footer from '@/components/damagecases/Footer.vue';

export default {
	name: 'RotatePicturesModal',
	components: { SaveButton, BaseImage, Footer },
	mixins: [Authentication, Validate, Formatter, DunningStatus],
	data() {
		return {
			pictureArray: [],
			rotation: [0],
			documentType: null,
			tempArray: [],
			label: null,
			overwriteUuid: null,
		};
	},
	mounted() {
		const storedValue = this.$store.getters.getRawUploadPictures;
		this.label = storedValue.label;
		this.documentType = storedValue.type;
		this.overwriteUuid = storedValue.miscOverwriteUuid;
		if (storedValue.pictures.includes('|')) {
			this.tempArray = storedValue.pictures.split('|');
			this.tempArray.forEach(element => {
				this.pictureArray.push({ imageData: element, rotation: 0 });
			});
		} else {
			this.tempArray.push(storedValue.pictures);
			this.pictureArray.push({ imageData: storedValue.pictures, rotation: 0 });
		}
	},
	computed: {
		damageCase() {
			return { ...this.$store.getters.getDamageCase };
		},
	},
	methods: {
		setTempDoc(event, index) {
			this.tempArray[index] = event;
		},
		rotateImage(index) {
			let rotation = this.pictureArray[index].rotation;
			if (rotation === 270) {
				rotation = 0;
			} else {
				rotation += 90;
			}
		},
		save() {
			if (this.label != null && (this.documentType === 'misc' || this.documentType === 'damageassessor_documents')) {
				DamagecasesApiFactory(defaultConfiguration.config(), defaultConfiguration.basePath, defaultConfiguration.axios)
					.pdfDamagecasesIdTypeUploadLabelPost(
						this.$route.params.processId,
						this.documentType,
						this.label,
						this.overwriteUuid != null ? this.overwriteUuid : undefined,
						this.tempArray,
					)
					.then(response => {
						this.$swal(this.$t('general.success').toString(), this.$t('saved_files_successfully').toString(), 'success').then(_ => {
							this.$router.push({
								name: 'management.process.edit',
								params: { processId: this.$store.getters.getDamageCase.id, customer: this.$store.getters.getDamageCase.customer.id },
							});
						});
					})
					.catch(error => {
						this.$swal(this.$t('general.error').toString(), this.$t('error_saving_files').toString(), 'error');
					});
			} else {
				DamagecasesApiFactory(defaultConfiguration.config(), defaultConfiguration.basePath, defaultConfiguration.axios)
					.pdfDamagecasesIdTypeUploadPost(this.$route.params.processId, this.documentType, this.tempArray)
					.then(response => {
						this.$swal(this.$t('general.success').toString(), this.$t('saved_files_successfully').toString(), 'success').then(_ => {
							this.$router.push({
								name: 'management.process.edit',
								params: { processId: this.$store.getters.getDamageCase.id, customer: this.$store.getters.getDamageCase.customer.id },
							});
						});
					})
					.catch(error => {
						this.$swal(this.$t('general.error').toString(), this.$t('error_saving_files').toString(), 'error');
					});
			}
		},
	},
};
</script>

<style>
.min-w-0 {
	min-width: 0 !important;
}
</style>
